import { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { toast } from "sonner";
import Navbar from "../components/Navbar";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return toast.error("Enter your email");
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Could not send reset email");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FDFBF7]" data-testid="forgot-password-page">
      <Navbar />
      <div className="px-6 py-16 max-w-md mx-auto">
        <div className="text-xs uppercase tracking-[0.4em] text-stone-500 mb-3">Account recovery</div>
        <h1 className="font-serif-display text-5xl font-light mb-3">Forgot your password?</h1>
        <p className="text-stone-600 mb-10">Enter your email and we'll send a reset link.</p>

        {sent ? (
          <div className="border border-emerald-300 bg-emerald-50 p-6" data-testid="forgot-success">
            <div className="font-serif-display text-2xl text-emerald-900 mb-2">Check your inbox</div>
            <p className="text-sm text-emerald-800">If an account exists for <strong>{email}</strong>, a reset link has been sent. The link expires in 1 hour.</p>
            <Link to="/login" className="inline-block mt-4 text-xs uppercase tracking-[0.2em] underline underline-offset-4">Back to sign in</Link>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <input data-testid="forgot-email" type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full px-4 py-3 bg-white border border-stone-300 outline-none focus:border-stone-900" required />
            <button data-testid="forgot-submit" disabled={busy} className="w-full py-3 bg-stone-900 text-white uppercase tracking-[0.3em] text-xs hover:bg-stone-800">{busy ? "Sending..." : "Send reset link"}</button>
            <div className="text-sm text-stone-600 mt-4"><Link to="/login" className="underline underline-offset-4">Back to sign in</Link></div>
          </form>
        )}
      </div>
    </div>
  );
}
